const ChevronIcon = (props: any) => {
	return (
		<svg
			id="chevron-down"
			xmlns="http://www.w3.org/2000/svg"
			width="18.773"
			height="14.442"
			viewBox="0 0 28.773 16.442"
			{...props}
		>
			<path
				id="Pfad_110"
				d="M-.4-.4A2.055,2.055,0,0,1,2.315-.569L2.508-.4,13.387,10.479,24.265-.4a2.055,2.055,0,0,1,2.713-.171l.193.171a2.055,2.055,0,0,1,.171,2.713l-.171.193L14.84,14.84a2.055,2.055,0,0,1-2.713.171l-.193-.171L-.4,2.508A2.055,2.055,0,0,1-.4-.4Z"
				transform="translate(1 1)"
				fill="#707070"
			/>
		</svg>
	);
};

export default ChevronIcon;
